'use strict';

angular.module('clientDashboardApp').directive('shortText', ['$log', function ($log) {
    return {
        restrict: 'A',
        scope: {
            text: '=',
            useQuotes: '='
        },
        replace: true,
        template: '<span>{{shortText}}<a href="" ng-if="hasMore" ng-click="loadRest()">[more]</a></span>',
        link: function (scope, elem, attrs, ctrl) {
            if(!angular.isDefined(scope.text)){
                return;
            }
            if(!angular.isDefined(parseInt(attrs.maxLength))){
                $log.warn('Invalid maxLength! maxLength:' + attrs.maxLength);
                return;
            }
            var maxLength = parseInt(attrs.maxLength);

            var cleanedText = scope.text.trim();
            var truncate = cleanedText.length > maxLength;
            //Use length + 1 to correctly handle end of word scenario.
            var shortText = cleanedText.substring(0,maxLength + 1);
            var lastSpace = shortText.lastIndexOf(" ");
            if(truncate){
                if(lastSpace > 0 && lastSpace <= maxLength){

                    //Include up to last non space character
                    shortText = shortText.substring(0,lastSpace);
                    shortText = shortText.replace(/[\s\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/,"");
                }else{
                    //There are no spaces so cut off all characters over max length
                    shortText = shortText.substring(0, maxLength);
                }
            }

            var expandable;
            if(!angular.isDefined(attrs.expandable)) {
                expandable=true;
            }else{
                expandable=attrs.expandable;
            }
            //If the base text was greater than the max length then include eclipses
            if(truncate){
                shortText += "...";
                scope.hasMore= expandable;
            }
            scope.shortText = shortText;

            if(scope.useQuotes){
              scope.shortText = '"'+scope.shortText+'"';
            }

            scope.loadRest = function(){
                scope.shortText = scope.text;
                scope.hasMore=false;
            }
        }
    }
}]);
